import { GlobalService } from './global.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  public loggedUserDetail: any;
  public walletBalance: any;
  public walletId: number;
  public menudetails;
  public menudetailsTrans;
  public menuStatus;
  public setLoggedUserDetail = new BehaviorSubject<any>({});
  castLoggedUserDetail = this.setLoggedUserDetail.asObservable();

  public setDisableMenu = new BehaviorSubject<any>(true);
  menuDetail = this.setDisableMenu.asObservable();

  public setKYCMenu = new BehaviorSubject<any>(true);
  kycDetail = this.setKYCMenu.asObservable();

  public setDisableMenuTrans = new BehaviorSubject<any>(true);
  menuDetailTrans = this.setDisableMenuTrans.asObservable();

  public setWalletBalance = new BehaviorSubject<any>({});
  castWalletBalance = this.setWalletBalance.asObservable();

  constructor(
    private globalService: GlobalService,
  ) {
    this.getLoggedUserDetail();
  }


  getLoggedUserDetail() {
    this.loggedUserDetail = JSON.parse(localStorage.getItem('LoggedUser'));
    // console.log(this.loggedUserDetail);
    // if (this.loggedUserDetail == null)
    //   return;
    this.walletId = this.loggedUserDetail.sProfile.sWalletId;
    this.setLoggedUserDetail.next(this.loggedUserDetail);

    this.getUserWalletDetail();



    // this.menudetailsTrans = JSON.parse(localStorage.getItem('isDisableMenuTrans'));

    // this.setDisableMenuTrans.next(this.menudetailsTrans);

  }

  getMenuDetails(menu) {
    // alert("service"+menu);
    this.setDisableMenu.next(menu);

  }

  getMenuDetailss(menus) {
    // alert("service"+menus);
    this.setDisableMenuTrans.next(menus);
  }

  getKycValue(kycmenu) {
    this.setKYCMenu.next(kycmenu)
  }

  getUserWalletDetail() {
    const params = {
      sWalletId: this.walletId
    };
    this.globalService.getWalletInfo(params).subscribe(data => {
      console.log(data);
      // this.walletId = data.uBalance;
      this.setWalletBalance.next(data.uBalance);
    });
  }
  updateLocalStorageSProfile(data: any) {
    this.loggedUserDetail.sProfile = data;
    localStorage.setItem('LoggedUser', JSON.stringify(this.loggedUserDetail));
  }
}
